import React, { useState } from 'react';
import { Field } from 'formik';
import { TextField, MenuItem, InputAdornment } from '@mui/material';
import { motion } from 'framer-motion';
import { MdVisibility, MdVisibilityOff, MdBusiness, MdEmail, MdLock, MdCategory } from 'react-icons/md';

const iconMap = {
  name: <MdBusiness />,
  email: <MdEmail />,
  password: <MdLock />,
  business_type: <MdCategory />,
  otp: <MdLock />,
};

const ModernInput = ({ comp, isSelect = false, options = [] }) => {
  const [visible, setVisible] = useState(false);

  if (isSelect) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="w-full"
      >
        <Field name={comp.name}>
          {({ field, form }) => (
            <TextField
              {...field}
              select
              fullWidth
              label={comp.label}
              variant="outlined"
              error={form.touched[comp.name] && !!form.errors[comp.name]}
              helperText={form.touched[comp.name] && form.errors[comp.name]}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '12px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px rgba(11, 70, 157, 0.15)',
                  },
                  '&.Mui-focused': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    boxShadow: '0 8px 25px rgba(11, 70, 157, 0.25)',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#333',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0B469D',
                },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                  color: '#333',
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <span className="text-[#0B469D] text-xl">{iconMap[comp.name] || <MdCategory />}</span>
                  </InputAdornment>
                ),
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        </Field>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full"
    >
      <Field name={comp.name}>
        {({ field, form }) => (
          <TextField
            {...field}
            type={comp.type === 'password' ? (visible ? 'text' : 'password') : comp.type}
            fullWidth
            label={comp.label}
            placeholder={comp.placeholder}
            variant="outlined"
            error={form.touched[comp.name] && !!form.errors[comp.name]}
            helperText={form.touched[comp.name] && form.errors[comp.name]}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(11, 70, 157, 0.15)',
                },
                '&.Mui-focused': {
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  boxShadow: '0 8px 25px rgba(11, 70, 157, 0.25)',
                },
              },
              '& .MuiInputLabel-root': {
                color: '#333',
                fontSize: '0.875rem',
                fontWeight: 500,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#0B469D',
              },
              '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                color: '#333',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <span className="text-[#0B469D] text-xl">
                    {iconMap[comp.name] || <MdEmail />}
                  </span>
                </InputAdornment>
              ),
              endAdornment: comp.type === 'password' && (
                <InputAdornment position="end">
                  <button
                    type="button"
                    onClick={() => setVisible(!visible)}
                    className="text-[#0B469D] hover:text-[#72a9fb] transition-colors"
                  >
                    {visible ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
                  </button>
                </InputAdornment>
              ),
            }}
          />
        )}
      </Field>
    </motion.div>
  );
};

export default ModernInput;

